import { KngBannerFactory } from '../banner';
import { KngContentFactory } from '../content/kng-content.factory';
import { KngFooterFactory } from '../footer/kng-footer.factory';
import { KngHeaderNavFactory } from '../nav/header-nav/kng-header-nav.factory';
import { KngCustomerState, KngShellState } from './definitions';

export class KngShellFactory 
{
	public static buildState(): KngShellState 
	{
		return {
			header: KngHeaderNavFactory.buildState(),
			banner: KngBannerFactory.buildState(),
			content: KngContentFactory.buildState(),
			footer: KngFooterFactory.buildState()
		};
	}
	public static buildCustomerState(): KngCustomerState 
	{
		return {
			hidden: false,
			warningNote: '',
			readOnly: '',
			endSession: '',
			username: ''
		};
	}
}
